import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../auth/auth.service";
import { HttpService } from "../services/http.service";
import {DadosJwtService} from "../services/dados-jwt.service";

@Injectable()

export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private dadosJwtService: DadosJwtService,
        private httpService: HttpService,
        ){}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) : Observable<boolean> | boolean {
      const token = this.dadosJwtService.get().jwt ?? (localStorage.getItem('token') ?? '');
        if(token){
            return true;
        }

        this.httpService.navigate(['/auth/login']);
        return false;
    }
}
